import React from "react";
import { Link, WithHostUrl } from "@quintype/components";
import PropTypes from "prop-types";
import { TAG_PAGE_URL_PREFIX } from "../../../../../../constants";
import styles from "./styles.m.css";

const Tags = ({ tags, className }) => {
  if (!tags || !tags.length) {
    return null;
  }
  return (
    <WithHostUrl>
      {({ primaryHostUrl }) => (
        <ul className={`${styles.tags} ${className}`}>
          {tags.filter(tag => tag !== null).map(tag => (
            <li key={tag.id} className={styles.tag}>
              <Link
                className={styles["tag-link"]}
                aria-label="Topic"
                href={primaryHostUrl + TAG_PAGE_URL_PREFIX + tag.slug}
              >
                {tag.name}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </WithHostUrl>
  );
};

Tags.propTypes = {
  className: PropTypes.string,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string
    })
  )
};

export default Tags;
